import React, {useEffect, useState} from 'react'
import {Accordion, Button, Col, Form, Modal, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import i18next from 'i18next'
import { RichText } from 'src/components'

interface PropsItem {
  data: any
  onStoreTexts(additional_text: any): any
}

export const AdditionalTextModal: React.FC<PropsItem> = (props) => {
    const {t} = useTranslation()    
    const [showModal, setShowModal] = useState(false)
    const [addTextLanguage, setAddTextLanguage] = useState('id')
    const [title, setTitle] = useState<any>('')
    const [customer_pic_name, setCustomerPicName] = useState<any>('')
    const [customer_pic_position, setCustomerPicPosition] = useState<any>('')
    const [terms_and_conditions, setTermsAndConditions] = useState<any>('')
    const [mail_body, setMailBody] = useState<any>('')
    const [customer_attn, setCustomerAttn] = useState<any>('')
    const [port_of_discharge, setPortOfDischarge] = useState<string>('')
    const [lain_lain, setLainLain] = useState<string>('')
    const [keterangan, setKeterangan] = useState<string>('')
    const [text_penutup, setTetxPenutup] = useState<string>('')
    const [no_izin_export, setNoIzinExport] = useState<string>('')
    const [title_en, setTitleEn] = useState<string>('')
    const [mail_body_en, setMailBodyEn] = useState<string>('')
    const [customer_attn_en, set_customer_attn_en] = useState<string>('')
    const [text_penutup_en, set_text_penutup_en] = useState<string>('')
    const [lain_lain_en, set_lain_lain_en] = useState<string>('')
    const [keterangan_en, set_keterangan_en] = useState<string>('')
    const [terms_and_conditions_en, set_terms_and_conditions_en] = useState<string>('')

    const handleOpenn = (e: any) => {
        const icon = e.target
        if (icon.classList.contains('a')) {
            icon?.classList.remove('a')
            icon?.classList.add('b')
        } else {
            icon?.classList.remove('b')
            icon?.classList.add('a')
        }
        const target = e.currentTarget.getAttribute('data-target')
        const fold = document.getElementById(target)
        fold?.classList.toggle('foldd-open')
    }

    useEffect(() => {
        setTitle(props.data?.additional_texts?.title)
        setCustomerPicName(props.data?.additional_texts?.customer_pic_name)
        setCustomerPicPosition(props.data?.additional_texts?.customer_pic_position)
        setTermsAndConditions(props.data?.additional_texts?.terms_and_conditions)
        setMailBody(props.data?.additional_texts?.mail_body || 'Bersama ini kami sampaikan persetujuan pembelian dengan rincian sebagai berikut:')
        setCustomerAttn(props.data?.additional_texts?.customer_attn)
        setPortOfDischarge(props.data?.additional_texts?.port_of_discharge)
        setLainLain(props.data?.additional_texts?.lain_lain)
        setKeterangan(props.data?.additional_texts?.keterangan)
        setTetxPenutup(props.data?.additional_texts?.text_penutup)
        setNoIzinExport(props.data?.additional_texts?.no_izin_export)
        setTitleEn(props.data?.additional_texts?.title_en)
        setMailBodyEn(props.data?.additional_texts?.mail_body_en || 'We hereby convey the purchase agreement with the following details:')
        set_customer_attn_en(props.data?.additional_texts?.customer_attn_en)
        set_text_penutup_en(props.data?.additional_texts?.text_penutup_en)
        set_lain_lain_en(props.data?.additional_texts?.lain_lain_en)
        set_keterangan_en(props.data?.additional_texts?.keterangan_en)
        set_terms_and_conditions_en(props.data?.additional_texts?.terms_and_conditions_en)
    }, [])

    const closeModal = () => setShowModal(false)

    const storeText = () => {
        props.onStoreTexts({
            title,
            customer_pic_name,
            customer_pic_position,
            terms_and_conditions,
            mail_body,
            customer_attn,
            port_of_discharge,
            lain_lain,
            keterangan,
            text_penutup,
            no_izin_export,
            title_en,
            mail_body_en,
            customer_attn_en,
            text_penutup_en,
            lain_lain_en,
            keterangan_en,
            terms_and_conditions_en,
        })
    }

    return (
        <div>
        <button className='btn btn-primary' onClick={() => setShowModal(true)}>
            {t('addtional')} {t('text')}
        </button>
        <Modal
            show={showModal}
            onHide={() => {
                storeText()
                closeModal()
            }}
            centered
            backdrop='static'
            keyboard={false}
            scrollable
            size='lg'
        >
            <Modal.Header closeButton>
            <Modal.Title>
                {t('addtional')} {t('text')}
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className='d-flex justify-content-end mb-3'>
                <div style={{maxWidth: 140}} className='btn-lang d-flex'>
                <button
                    className={
                    'd-flex align-items-center me-1 ' + (addTextLanguage == 'id' ? 'active' : '')
                    }
                    onClick={() => setAddTextLanguage('id')}
                >
                    <h6 className='ms-1'>Ind</h6>
                </button>
                <button
                    className={
                    'd-flex align-items-center me-1 ' + (addTextLanguage == 'en' ? 'active' : '')
                    }
                    onClick={() => setAddTextLanguage('en')}
                >
                    <h6 className='ms-1'>Eng</h6>
                </button>
                </div>
            </div>

            {addTextLanguage == 'id' && (
                <div>
                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'Judul'}
                        onClick={handleOpenn}
                        id='titlee'
                    >
                        <div className='text-light'>{t('Judul')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'Judul'}>
                    <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setTitle(e.target.value)}
                        placeholder={t('Judul')}
                        defaultValue={title}
                    />
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'nama'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('customer pic name')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'nama'}>
                    <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setCustomerPicName(e.target.value)}
                        placeholder={t('customer pic name')}
                        defaultValue={customer_pic_name}
                    />
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveName}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'Position'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('customer pic position')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'Position'}>
                    <RichText
                        containerClassName='mt-4'
                        content={customer_pic_position}
                        onUpdate={({editor}) => setCustomerPicPosition(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSavePosition}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'terms_and_conditions'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('terms_and_conditions')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'terms_and_conditions'}>
                    <RichText
                        containerClassName='mt-4'
                        content={terms_and_conditions}
                        onUpdate={({editor}) => setTermsAndConditions(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveSyarat}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'mail_body'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('mail_body')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'mail_body'}>
                    <RichText
                        containerClassName='mt-4'
                        content={mail_body}
                        onUpdate={({editor}) => setMailBody(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveMail}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'customer_attn'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('customer_attn')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'customer_attn'}>
                    <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setCustomerAttn(e.target.value)}
                        placeholder={t('customer_attn')}
                        defaultValue={customer_attn}
                    />
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveAttn}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'port_of_discharge'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('port_of_discharge')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'port_of_discharge'}>
                    <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setPortOfDischarge(e.target.value)}
                        placeholder={t('port_of_discharge')}
                        defaultValue={port_of_discharge}
                    />
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSavePort}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'other'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('other')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'other'}>
                    <RichText
                        containerClassName='mt-4'
                        content={lain_lain}
                        onUpdate={({editor}) => setLainLain(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'order-keterangan'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('order-keterangan')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'order-keterangan'}>
                    <RichText
                        containerClassName='mt-4'
                        content={keterangan}
                        onUpdate={({editor}) => setKeterangan(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'textPenutup'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('textPenutup')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'textPenutup'}>
                    <RichText
                        containerClassName='mt-4'
                        content={text_penutup}
                        onUpdate={({editor}) => setTetxPenutup(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveTextPenutup}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'nomorIzinExport'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('nomorIzinExport')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'nomorIzinExport'}>
                    <RichText
                        containerClassName='mt-4'
                        content={no_izin_export}
                        onUpdate={({editor}) => setNoIzinExport(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveNoExport}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                </div>
            )}
            {addTextLanguage == 'en' && (
                <div>
                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'Judul'}
                        onClick={handleOpenn}
                        id='titlee'
                    >
                        <div className='text-light'>{t('Judul')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'Judul'}>
                    <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => setTitleEn(e.target.value)}
                        placeholder={t('Judul')}
                        defaultValue={title_en}
                    />
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveTitle}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'terms_and_conditions'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('terms_and_conditions')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'terms_and_conditions'}>
                    <RichText
                        containerClassName='mt-4'
                        content={terms_and_conditions_en}
                        onUpdate={({editor}) => set_terms_and_conditions_en(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveSyarat}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'mail_body'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('mail_body')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'mail_body'}>
                    <RichText
                        containerClassName='mt-4'
                        content={mail_body_en}
                        onUpdate={({editor}) => setMailBodyEn(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveMail}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'customer_attn'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('customer_attn')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'customer_attn'}>
                    <Form.Control
                        className='mt-3'
                        aria-label='Default select example'
                        onChange={(e: any) => set_customer_attn_en(e.target.value)}
                        placeholder={t('customer_attn')}
                        defaultValue={customer_attn_en}
                    />
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveAttn}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'other'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('other')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'other'}>
                    <RichText
                        containerClassName='mt-4'
                        content={lain_lain_en}
                        onUpdate={({editor}) => set_lain_lain_en(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'order-keterangan'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('order-keterangan')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'order-keterangan'}>
                    <RichText
                        containerClassName='mt-4'
                        content={keterangan_en}
                        onUpdate={({editor}) => set_keterangan_en(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    </div>
                </Form.Group>
                <hr />

                <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                    <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'textPenutup'}
                        onClick={handleOpenn}
                    >
                        <div className='text-light'>{t('textPenutup')}</div>
                    </button>
                    </div>
                    <div className='fold' id={'target' + 'textPenutup'}>
                    <RichText
                        containerClassName='mt-4'
                        content={text_penutup_en}
                        onUpdate={({editor}) => set_text_penutup_en(editor.getHTML())}
                    >
                        <div style={{display: 'none'}}>&nbsp;</div>
                    </RichText>
                    {/* <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary mt-3' onClick={handleSaveTextPenutup}>
                            {t('Save')}
                        </button>
                        </div> */}
                    </div>
                </Form.Group>
                <hr />
                </div>
            )}
            </Modal.Body>
        </Modal>
        </div>
    )
}
